import i18n from '../../client/i18n';

function format(diff, divisor, unit, prevKey) {
  const val = Math.floor(diff / divisor);

  // If val <= 1, use the singular form (e.g., "a minute ago", "yesterday")
  if (val <= 1) {
    return i18n.t(prevKey, { ns: 'miscellaneous' });
  }

  // For val > 1, use plural forms with count interpolation
  return i18n.t(`timeAgo.${unit}sAgo`, { ns: 'miscellaneous', count: val });
}

export default function ago(date) {
  const diff = Math.abs(Date.now() - date.getTime());
  const { units } = ago;

  if (diff < 60000) { // less than a minute
    return i18n.t('timeAgo.justNow', { ns: 'miscellaneous' });
  }

  for (let i = 0; i < units.length; i += 1) {
    if (diff < units[i].max) {
      return format(diff, units[i].value, units[i].name, units[i].prevKey);
    }
  }

  return '';
}

ago.units = [
  { max: 2760000, value: 60000, name: 'minute', prevKey: 'timeAgo.aMinuteAgo' }, // max: 46 minutes
  { max: 72000000, value: 3600000, name: 'hour', prevKey: 'timeAgo.anHourAgo' }, // max: 20 hours
  { max: 518400000, value: 86400000, name: 'day', prevKey: 'timeAgo.yesterday' }, // max: 6 days
  { max: 2419200000, value: 604800000, name: 'week', prevKey: 'timeAgo.lastWeek' }, // max: 28 days
  { max: 28512000000, value: 2592000000, name: 'month', prevKey: 'timeAgo.lastMonth' }, // max: 11 months
  { max: Infinity, value: 31536000000, name: 'year', prevKey: 'timeAgo.lastYear' },
];
